export default {
  MuiButton: {
    variant: 'contained',
    color: 'primary',
    fullWidth: true,
  },
  MuiTextField: {
    InputLabelProps: {
      shrink: true,
    },
  },
};
